import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import FiscalYearForm from '../Forms/FiscalYearForm';

const AddEditFiscalYearModal = ({ data, isOpen, isEdit, toggle }) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={toggle}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={toggle}>
				{isEdit ? 'Editar' : 'Agregar'} Año Fiscal
			</ModalHeader>
			<FiscalYearForm
				dataFiscalYear={data}
				isEdit={isEdit}
				handleToggleModal={toggle}
			/>
		</Modal>
	);
};

export default AddEditFiscalYearModal;
